import React, { useEffect } from "react";
import NavBar from "../NavBar/NavBar";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import "./Membership.css";
import { Helmet } from "react-helmet-async";

const Membership = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",   // Change to "smooth" if you prefer
    });
  }, []);

  const plans = [
    {
      id: 1,
      planName: "Premium Plan",
      price: "40,000",
      period: "month",
      billing: "Billed monthly • Cancel anytime",
      features: [
        "Unlimited access to all gymnastics classes",
        "Up to 4 family members included",
        "Priority booking for parties & events",
        "Free party room usage (2 hours/month)",
        "Exclusive workshops and events",
        "10% discount on all add-ons",
        "Detailed monthly progress report",
      ],
    },
    {
      id: 2,
      planName: "Annual Premium",
      price: "400,000",
      period: "year",
      billing: "Billed annually • Save 15%",
      features: [
        "Unlimited access to all gymnastics classes",
        "Up to 4 family members included",
        "Priority booking for parties & events",
        "Free party room usage (2 hours/month)",
        "Exclusive workshops and events",
        "10% discount on all add-ons",
        "Detailed monthly progress report",
      ],
    },
    {
      id: 3,
      planName: "Family Plan",
      price: "65,000",
      period: "month",
      billing: "Billed monthly • Best for families",
      features: [
        "Unlimited access to all gymnastics classes",
        "Up to 6 family members included",
        "Priority booking for parties & events",
        "Free party room usage (4 hours/month)",
        "Exclusive workshops and events",
        "15% discount on all add-ons",
        "Detailed monthly progress report",
      ],
    },
  ];

  const handleSubscribe = (planName) => {
    navigate("/membership/checkout");
  };

  return (
    <>
     <Helmet>
      <title>MemberShip</title>
      <meta
      name="description"
      content="
     "/>
     <link rel="canonical" href="/"/>
     </Helmet>   

    <div className="kiga-membership-page">
      <NavBar />

      {/* Hero Section */}
      <section
        className="contact-hero"
        style={{
          background: `linear-gradient(135deg, rgba(0,0,0,0.75), rgba(0,0,0,0.6)), url('/images/moving2.jpg')`,
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="about-hero-text">
          <span className="hero-subtitle animate-slide-up">Welcome to</span>
          <h1 className="animate-slide-up-delay">
            Kigali International <span>Gymnastics Academy</span>
          </h1>
          <div className="hero-breadcrumb animate-slide-up-delay-2">
            <Link to="/">Home</Link>
            <span>/</span>
            <span className="current">Membership</span>
          </div>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" />
          </svg>
        </div>
      </section>

      {/* Plans Section */}
      <section className="kiga-membership-plan-section">
        <div className="kiga-membership-plan-container">
          {plans.map((plan) => (
            <div
              className={`kiga-membership-plan-subscription-card ${
                plan.planName === "Annual Premium" ? "popular" : ""
              }`}
              key={plan.id}
            >
              <div className="kiga-membership-plan-name">{plan.planName}</div>

              <div className="kiga-membership-plan-price">
                Rwf {plan.price.toLocaleString()}
                <span>/{plan.period}</span>
              </div>

              <div className="kiga-membership-plan-billing">{plan.billing}</div>

              <div className="kiga-membership-plan-features">
                <ul>
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>

              <button
                className="kiga-membership-plan-subscribe-btn kiga-membership-plan-btn-premium"
                onClick={() => handleSubscribe(plan.planName)}
              >
                Subscribe to {plan.planName}
              </button>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
};

export default Membership;